import { API_ENDPOINTS } from './Constants';
import { apiFetch, parseApiResponse } from './apiHelper';

const BorrowingService = {
    addBorrowing: async (userId, bookId) => {
        try {
            const response = await apiFetch(API_ENDPOINTS.BORROWING, {
                method: "POST",
                credentials: "include",
                body: JSON.stringify({ userId, bookId }),
            });

            if (!response.ok) {
                const errorData = await parseApiResponse(response);
                throw new Error(errorData.message || errorData || "Greška pri dodavanju posudbe");
            }

            return true;
        } catch (error) {
            throw error;
        }
    },

    returnBook: async (userId, bookId) => {
        try {
            const response = await apiFetch(API_ENDPOINTS.BORROWING_RETURN, {
                method: "PUT",
                credentials: "include",
                body: JSON.stringify({ userId, bookId }),
            });

            if (!response.ok) {
                const errorData = await parseApiResponse(response);
                throw new Error(errorData.message || errorData || "Greška pri vraćanju knjige");
            }

            return true;
        } catch (error) {
            throw error;
        }
    },
};

export default BorrowingService;
